import title from "../media/images/karakutiTitle.png";
import image2 from "../media/images/karakuriM.jpg";
import "./Karakuri.css";
const Karakuri = () => {
    return (  
        <div className="karakuri">
            <div className="karakuriTitle">
                <img src={title} alt="d"/>
            </div>
            <div className="karakuriText">
                 <div className="blockText">
                    <div className="karakuriBigText">
                        <p >LOW COST AUTOMATION</p>
                        <p >KARAKURI LIFTER</p>     
                    </div>
                    <div className="karakuriSmall">
                        <p>
                            🚀 Improve Efficiency. Cut Costs. Go Lean – with Gravity.

                            Reduce manual handling, cut costs, and boost productivity with tailor-made Karakuri Lifter systems – all without electricity or complex automation.<br/>
                            💡 Based on the ingenious Karakuri principle, these mechanical lifters use gravity, springs, and levers to move materials effortlessly. The result?<br/>
                            ✅ Lower energy use<br/>
                            ✅ Less operator strain<br/>
                            ✅ Faster, safer workflows<br/>
                            We design, produce, and install every solution to fit your unique operations – from lean manufacturing to warehouse logistics.<br/>
                            ♻️ Sustainable by design. Efficient by nature.<br/>
                            🔧 Ready to improve your internal logistics the smart way?<br/>
                            Let’s build together your custom Karakuri solution.<br/>
                        </p>
                    </div>
                </div>
                <div className="karakuriBlockImage">
                    <img src={image2} alt=""/>
                </div>
            </div>
            <div className="karakuriBlockImagePhone">
                <img src={image2} alt=""/>
            </div>
            <div className="contactBlockK">
                <p>©Ecomode Studio 2025 - All Rights reserved</p>
            </div>
        </div>
    );
}
 
export default Karakuri;